import { render } from "./RFQDetail.vue?vue&type=template&id=c77fd8aa"
import script from "./RFQDetail.vue?vue&type=script&lang=js"
export * from "./RFQDetail.vue?vue&type=script&lang=js"
script.render = render

export default script